import { apiRequest, ApiResponse } from '../request'

/** Canal por onde a mensagem sai. Espelha `NOTIFICATION_CHANNELS` do backend. */
export type NotificationChannel = 'email' | 'whatsapp' | 'inApp'

export const NOTIFICATION_CHANNELS: NotificationChannel[] = [
    'email',
    'whatsapp',
    'inApp',
]

/**
 * O que vem gravado na entidade. Tudo opcional: **ausente é desligado**, e é o que
 * faz "só recebe quem consentiu" valer para os cadastros que já existiam.
 */
export interface NotificationPreferences {
    channels?: Partial<Record<NotificationChannel, boolean>>
    consentAt?: string
    consentById?: number
}

/**
 * Entidades que têm preferência de notificação. O caminho da API é o único que muda
 * entre elas — o componente é o mesmo.
 */
export type NotifiableEntityType =
    | 'partner'
    | 'professional'
    | 'supplier'
    | 'hospital'

const ENTITY_PATHS: Record<NotifiableEntityType, string> = {
    partner: 'partners',
    professional: 'professionals',
    supplier: 'suppliers',
    hospital: 'hospitals',
}

/**
 * Liga/desliga canais. Manda só o canal alterado: o backend faz patch parcial e
 * preserva os outros.
 */
export async function updateNotificationPreferences(
    entityType: NotifiableEntityType,
    id: number,
    patch: Partial<Record<NotificationChannel, boolean>>
): Promise<ApiResponse<{ id: number; notificationPreferences: NotificationPreferences }>> {
    return apiRequest(
        `${ENTITY_PATHS[entityType]}/${id}/notification-preferences`,
        { data: patch },
        'patch'
    )
}

/** Resolve o que veio da entidade — ausência de canal é "desligado". */
export function readChannels(
    preferences?: NotificationPreferences | null
): Record<NotificationChannel, boolean> {
    return {
        email: preferences?.channels?.email === true,
        whatsapp: preferences?.channels?.whatsapp === true,
        inApp: preferences?.channels?.inApp === true,
    }
}
